/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ChartLine(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M223.99951,200h-184V163.63232L96.39014,114.291l58.8125,44.10888a7.99913,7.99913,0,0,0,10.06738-.37939l64-56a7.99962,7.99962,0,1,0-10.53516-12.041L159.61475,141.709,100.80225,97.6001a7.99909,7.99909,0,0,0-10.06739.37939L39.99951,142.37305V48a8,8,0,0,0-16,0V208a8.00039,8.00039,0,0,0,8,8h192a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ChartLine;
